

























import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import Context from "@/mixins/context";

// Enums
import { DataModules } from "@/store/modules/data";

// Types
import { IState } from "@/store";
import { IClient } from "@/models/clients";

@Component({
  components: {
    "client-emails-list": () =>
      import("@/components/app/global/client/clientEmailsList.vue")
  },
  computed: {
    ...mapState({
      dataScope(state: IState, getters) {
        return getters[`data/${DataModules.CLIENTS_EMAILS}/clientScope`](
          this.clientId
        );
      }
    })
  }
})
export default class ClientEmails extends Mixins(Context) {
  // Props

  @Prop({ required: true })
  public clientId!: IClient["id"];

  @Prop({ default: false })
  public isStaged!: boolean;

  // Data

  public dataScope!: string;
  public canCreate = this.$userCan("create_client_email");

  // Computed

  public get cta() {
    if (!this.canCreate) return "";
    return this.$t("_action.add_object", {
      object: (this.$t(`_.email`) as string).toLowerCase()
    });
  }

  public createEmail() {
    if (!this.canCreate) return;
    this.$store.dispatch("ui/open/modal", {
      config: {
        component: () =>
          import("@/components/app/global/client/addEditClientEmailsModal.vue"),
        props: {
          clientId: this.clientId
        }
      }
    });
  }
}
